/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'
import store from '@/store/'
import { serialize } from '@/utils/util'
import { Message } from 'element-ui'
import website from '@/config/website'
import NProgress from 'nprogress' // progress bar
import { getToken } from '@/utils/auth'

axios.defaults.timeout = 60000
import {
    env,
    baseUrl
} from '@/config/env'

if (env.NODE_ENV !== 'development') {
    axios.defaults.baseURL = baseUrl
}
//返回其他状态吗
axios.defaults.validateStatus = function(status) {
        return status >= 200 && status <= 500 // 默认的
    }
    //跨域请求，允许保存cookie
axios.defaults.withCredentials = true

NProgress.configure({
    showSpinner: false
})

axios.getUrl = url => {
    return `${baseUrl}${url}?token=${store.getters.token}`
}

const pulseLoader = val => {
    store.dispatch('setPulseLoader', val)
}

/**
 * HTTP request 拦截
 */
axios.interceptors.request.use(config => {
        NProgress.start() // start progress bar
        const pulseLoaderList = ['/api/auth/jwt/verify']
        const meta = (config.meta || {})
        const isToken = meta.isToken === false
        const token = store.getters.token || getToken()
        if (token && !isToken) {
            config.headers[`token`] = token // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        }
        // headers中配置serialize为true开启序列化
        if ((config.method !== 'get') && meta.isSerialize === true) {
            config.data = serialize(config.data)
        }
        if(pulseLoaderList.indexOf(config.url) < 0){
            pulseLoader(true)
        }
        return config
    }, error => {
        pulseLoader(false)
        Message.error(error.message)
        return Promise.reject(error)
    })

/**
 * HTTP response 拦截
 */
axios.interceptors.response.use(res => {
    NProgress.done()
    pulseLoader(false)
        // window.scrollTo(0, 0)
    const {
        code,
        msg,
        data,
        message
    } = res.data
    const status = code || res.status
    const statusWhiteList = website.statusWhiteList || []
    const strMessage = msg || message || '未知错误'
        // 如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status))
        return data || res.data
            // 如果是401则跳转到登录页面
            // if (status === 70002 || (status >= 20001 && status <= 20005) || (status >= 200006 && status <= 200009) || status === 503)
    if (status === 70002 || (status >= 20001 && status <= 20005 && status!==20002) || (status >= 200006 && status <= 200009)){
        if(res.config.url.indexOf('/api/shenbao')>-1) {
            store.dispatch('Fed404LogOut')
        }else{
            store.dispatch('FedLogOut')
        }
        // 如果请求为非200否者默认统一处理
    }
    if (!(status === 1 || status === 200)) {
        Message.error(strMessage)
        return Promise.reject(strMessage)
    }
    return status === 1 ? data : res.data
}, error => {
    NProgress.done()
    pulseLoader(false)
    Message.error(error.message)
    return Promise.reject(error)
})

let http = (url, params = {}, method = 'get') => {
    return axios({
        url,
        method,
        ...params
    })
}

export default http

export const getUrl = url => {
    return `${baseUrl}${url}?token=${store.getters.token}`
}
